import { mask } from 'vue-the-mask';

export default {
  directives: { mask },
  data() {
    return {
      phoneMask: '',
      phoneMaskUkraine: '+380 (##) ###-##-##',
      phoneMaskPragueUkraine: '+### (##) ###-##-##',  //mask compatible for numbers of Ukraine and Prague
    };
  },
  computed: {
    withPraguePhones() {
      return 'VUE_APP_TYPE' in process.env && process.env.VUE_APP_TYPE === 'limpi';
    },
    withPhoneCode() {
      return this.withPraguePhones;
    },
    initPhoneMask() {
      return this.withPraguePhones ? this.phoneMaskPragueUkraine : this.phoneMaskUkraine;
    },
    initPhoneRule() {
      return this.withPraguePhones ? 'phone_prague' : 'phone';
    },
  },
  mounted() {
    this.phoneMask = this.initPhoneMask;
  },
};
